import * as React from 'react';

// Divide alpha coverage on opaque RGB, then restore it to alpha. Keeping
// intrinsic paint alpha separate prevents geometry/animation from fading twice.
export default function AlphaRatio({
  numerator,
  denominator,
  result,
}: {
  numerator: string;
  denominator: string;
  result: string;
}) {
  return (
    <>
      <feColorMatrix
        in={numerator}
        type="matrix"
        values="0 0 0 1 0  0 0 0 1 0  0 0 0 1 0  0 0 0 0 1"
        result={`${result}-numerator`}
      />
      <feColorMatrix
        in={denominator}
        type="matrix"
        values="0 0 0 -1 1  0 0 0 -1 1  0 0 0 -1 1  0 0 0 0 1"
        result={`${result}-inverse`}
      />
      <feBlend
        in={`${result}-inverse`}
        in2={`${result}-numerator`}
        mode="color-dodge"
        result={`${result}-ratio`}
      />
      <feColorMatrix
        in={`${result}-ratio`}
        type="matrix"
        values="0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  1 0 0 0 0"
        result={result}
      />
    </>
  );
}
